import axios from 'axios'
import { cca_config } from '../../../CCA_ENV_CONF/env'
import router from '@/router'
import store from '@/store'

export default () => {
    const auth_info = store.getters['authInfo']

    let token = ''
    if (auth_info) {
        token = (Object.prototype.hasOwnProperty.call(auth_info, 'access_token'))?auth_info.access_token:''
    }
    

    const instance = axios.create({
        baseURL: cca_config.C_URL+cca_config.C_URL_CONFIG_API,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })

    // Add a response interceptor
    instance.interceptors.response.use(
        response => response, // Return response if successful
        error => {
            if (error.response && error.response.status === 401) {
                console.warn("Token expired. Logging out...");
                localStorage.clear();
                router.push('/login'); // Redirect to login page
            }
            return Promise.reject(error);
        }
    );
    return instance
}